export default "__VITE_ASSET__3467fb03__"